import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "sx" }
const _hoisted_2 = { class: "sx-grid" }
const _hoisted_3 = { class: "sx-field" }
const _hoisted_4 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_5 = { class: "sx-field" }
const _hoisted_6 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_7 = {
  key: 1,
  class: "sx-help"
}
const _hoisted_8 = { class: "sx-field" }
const _hoisted_9 = { class: "sx-color" }
const _hoisted_10 = {
  class: "sx-swatches",
  role: "group",
  "aria-label": "Couleurs suggérées"
}
const _hoisted_11 = ["aria-label", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_13 = { class: "sx-field" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_16 = {
  class: "sx-card",
  "aria-labelledby": "st-list-title"
}
const _hoisted_17 = { class: "sx-list-head" }
const _hoisted_18 = { id: "st-list-title" }
const _hoisted_19 = { class: "sx-count" }
const _hoisted_20 = { class: "sx-search" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "sx-load-error",
  role: "alert"
}
const _hoisted_23 = {
  key: 2,
  class: "sx-empty"
}
const _hoisted_24 = {
  key: 3,
  class: "sx-rows"
}
const _hoisted_25 = ["title"]
const _hoisted_26 = ["value", "aria-label", "onInput"]
const _hoisted_27 = { class: "sx-main" }
const _hoisted_28 = { class: "sx-code" }
const _hoisted_29 = { class: "sx-actions" }
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_32 = ["aria-label", "onClick"]
const _hoisted_33 = {
  ref: "editModalEl",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "st-edit-title",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_35 = { class: "modal-body" }
const _hoisted_36 = { class: "sx-field" }
const _hoisted_37 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_38 = { class: "sx-field" }
const _hoisted_39 = { class: "sx-code" }
const _hoisted_40 = { class: "sx-field" }
const _hoisted_41 = { class: "sx-color" }
const _hoisted_42 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[33] || (_cache[33] = _createElementVNode("header", { class: "sx-head" }, [
      _createElementVNode("span", { class: "sx-eyebrow" }, "Paramètres"),
      _createElementVNode("h1", { class: "sx-title" }, "Statuts des colis"),
      _createElementVNode("p", { class: "sx-sub" }, "Nom et couleur de chaque étape du colis, affichés dans les listes, les suivis et les tableaux de bord.")
    ], -1)),
    _createVNode(_component_SettingsNav),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "sx-card sx-form-card",
        novalidate: "",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _cache[18] || (_cache[18] = _createElementVNode("header", { class: "sx-card-head" }, [
          _createElementVNode("span", { class: "sx-card-icon" }, [
            _createElementVNode("i", {
              class: "ph ph-plus-circle",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, "Nouveau statut"),
            _createElementVNode("p", null, "Le code est l'identifiant technique, il ne pourra plus être modifié.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "st-new-name" }, [
            _createTextVNode("Nom "),
            _createElementVNode("span", {
              class: "sx-req",
              "aria-hidden": "true"
            }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            id: "st-new-name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newStatut.name) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
            maxlength: "100",
            placeholder: "Ex. Retour en cours",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNameInput && _ctx.onNameInput(...args)))
          }, null, 34), [
            [_vModelText, _ctx.newStatut.name]
          ]),
          (_ctx.errors.name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.errors.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "st-new-code" }, [
            _createTextVNode("Code "),
            _createElementVNode("span", {
              class: "sx-req",
              "aria-hidden": "true"
            }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            id: "st-new-code",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newStatut.code) = $event)),
            type: "text",
            class: _normalizeClass(["form-control sx-mono", { 'is-invalid': _ctx.errors.code }]),
            maxlength: "50",
            placeholder: "RETOUR_EN_COURS",
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCodeInput && _ctx.onCodeInput(...args)))
          }, null, 34), [
            [_vModelText, _ctx.newStatut.code]
          ]),
          (_ctx.errors.code)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errors.code), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "MAJUSCULES, chiffres et _ uniquement. Généré depuis le nom."))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "st-new-color" }, "Couleur", -1)),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              id: "st-new-color",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newStatut.code_color) = $event)),
              type: "color",
              "aria-label": "Choisir une couleur"
            }, null, 512), [
              [_vModelText, _ctx.newStatut.code_color]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newStatut.code_color) = $event)),
              type: "text",
              class: "form-control",
              maxlength: "7",
              "aria-label": "Code couleur"
            }, null, 512), [
              [_vModelText, _ctx.newStatut.code_color]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.swatches, (c) => {
              return (_openBlock(), _createElementBlock("button", {
                key: c,
                type: "button",
                style: _normalizeStyle({ background: c }),
                class: _normalizeClass({ 'is-active': _ctx.newStatut.code_color.toLowerCase() === c.toLowerCase() }),
                "aria-label": `Couleur ${c}`,
                onClick: ($event: any) => (_ctx.newStatut.code_color = c)
              }, null, 14, _hoisted_11))
            }), 128))
          ]),
          (_ctx.errors.code_color)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.errors.code_color), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[16] || (_cache[16] = _createElementVNode("label", null, "Aperçu", -1)),
          _createElementVNode("span", {
            class: "st-pill",
            style: _normalizeStyle(_ctx.pillStyle(_ctx.newStatut.code_color))
          }, _toDisplayString(_ctx.newStatut.name || "Nom du statut"), 5)
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary sx-submit",
          disabled: _ctx.saving
        }, [
          (_ctx.saving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15))
            : _createCommentVNode("", true),
          _cache[17] || (_cache[17] = _createTextVNode(" Ajouter le statut ", -1))
        ], 8, _hoisted_14)
      ], 32),
      _createElementVNode("section", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h2", _hoisted_18, [
            _cache[19] || (_cache[19] = _createTextVNode("Statuts ", -1)),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.statuts.length), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[20] || (_cache[20] = _createElementVNode("i", {
              class: "ph ph-magnifying-glass",
              "aria-hidden": "true"
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search) = $event)),
              type: "search",
              placeholder: "Rechercher un statut…",
              "aria-label": "Rechercher un statut"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createElementVNode("span", {
                  key: n,
                  class: "sx-skel"
                })
              }), 64))
            ]))
          : (_ctx.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[21] || (_cache[21] = _createElementVNode("i", {
                  class: "ph ph-warning-circle",
                  "aria-hidden": "true"
                }, null, -1)),
                _cache[22] || (_cache[22] = _createTextVNode(" Impossible de charger les statuts. ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.fetchStatus && _ctx.fetchStatus(...args)))
                }, "Réessayer")
              ]))
            : (!_ctx.filtered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[23] || (_cache[23] = _createElementVNode("i", {
                    class: "ph ph-flag",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.search ? "Aucun statut ne correspond à votre recherche." : "Aucun statut pour le moment."), 1)
                ]))
              : (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: _normalizeClass(["sx-row", { 'is-new': item.id === _ctx.lastAddedId }])
                    }, [
                      _createElementVNode("label", {
                        class: "st-dot",
                        title: `Changer la couleur de ${item.name}`
                      }, [
                        _createElementVNode("input", {
                          type: "color",
                          value: item.code_color || '#ffffff',
                          "aria-label": `Couleur de ${item.name}`,
                          onInput: ($event: any) => (_ctx.onColorChange(item.id, $event.target.value))
                        }, null, 40, _hoisted_26),
                        _createElementVNode("span", {
                          style: _normalizeStyle({ background: item.code_color || '#ffffff' })
                        }, null, 4)
                      ], 8, _hoisted_25),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                        _createElementVNode("small", null, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(item.code), 1)
                        ])
                      ]),
                      _createElementVNode("span", {
                        class: "st-pill",
                        style: _normalizeStyle(_ctx.pillStyle(item.code_color))
                      }, _toDisplayString(item.name), 5),
                      _createElementVNode("div", _hoisted_29, [
                        (_ctx.isColorDirty(item))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-sm btn-primary",
                              disabled: _ctx.savingId === item.id,
                              onClick: ($event: any) => (_ctx.updateColor(item))
                            }, [
                              (_ctx.savingId === item.id)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                                : _createCommentVNode("", true),
                              _cache[24] || (_cache[24] = _createTextVNode(" Enregistrer ", -1))
                            ], 8, _hoisted_30))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sx-icon-btn",
                          "aria-label": `Modifier ${item.name}`,
                          title: "Modifier",
                          onClick: ($event: any) => (_ctx.openEdit(item))
                        }, _cache[25] || (_cache[25] = [
                          _createElementVNode("i", {
                            class: "ph ph-pencil-simple",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]), 8, _hoisted_32)
                      ])
                    ], 2))
                  }), 128))
                ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("form", {
          class: "modal-content",
          novalidate: "",
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)), ["prevent"]))
        }, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h2", {
              id: "st-edit-title",
              class: "modal-title"
            }, "Modifier le statut"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { for: "st-edit-name" }, [
                _createTextVNode("Nom "),
                _createElementVNode("span", {
                  class: "sx-req",
                  "aria-hidden": "true"
                }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "st-edit-name",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.edit.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.editErrors.name }]),
                maxlength: "100"
              }, null, 2), [
                [_vModelText, _ctx.edit.name]
              ]),
              (_ctx.editErrors.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.editErrors.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[27] || (_cache[27] = _createElementVNode("label", null, "Code", -1)),
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.edit.code), 1),
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sx-help" }, "Le code est une clé système et ne peut pas être modifié.", -1))
            ]),
            _createElementVNode("div", _hoisted_40, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { for: "st-edit-color" }, "Couleur", -1)),
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  id: "st-edit-color",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.edit.code_color) = $event)),
                  type: "color",
                  "aria-label": "Choisir une couleur"
                }, null, 512), [
                  [_vModelText, _ctx.edit.code_color]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.edit.code_color) = $event)),
                  type: "text",
                  class: "form-control",
                  maxlength: "7",
                  "aria-label": "Code couleur"
                }, null, 512), [
                  [_vModelText, _ctx.edit.code_color]
                ])
              ]),
              (_ctx.editErrors.code_color)
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.editErrors.code_color), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", {
              class: "st-pill",
              style: _normalizeStyle(_ctx.pillStyle(_ctx.edit.code_color))
            }, _toDisplayString(_ctx.edit.name || "Nom du statut"), 5)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[31] || (_cache[31] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: _ctx.savingEdit
            }, [
              (_ctx.savingEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                : _createCommentVNode("", true),
              _cache[30] || (_cache[30] = _createTextVNode(" Enregistrer ", -1))
            ], 8, _hoisted_44)
          ])
        ], 32)
      ])
    ], 512)
  ]))
}